import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import LeaderSearchContainer from '../../../features/page/copyTrading/leader/LeaderSearchContainer'
import useQueryLeaderList from '../../../hooks/api/leader/useQueryLeaderList'
import {ILeader, LeaderSortBy, leaderAllTimeProfit} from '../../../apis/leader/getLeader'
import LeaderListTable from '../../../features/page/copyTrading/leader/LeaderListTable'
import WizPagination from '../../../components/pagination/WizPagination'
import Text from '../../../components/text/Text'

interface IProps {
    className?: string
}

// 서버가 지원하는 정렬은 created_at / copier / mdd 뿐이다.
// profit은 서버 정렬이 없어 현재 페이지 안에서만 정렬한다(라벨에 그대로 표기).
const PAGE_SORT = 'profit'

const CopyLeaderPage: React.FC<IProps> = ({className}) => {
    const [searchKeyword, setSearchKeyword] = useState('')
    const [exchange, setExchange] = useState('')
    const [sortBy, setSortBy] = useState('created_at')

    const [currentPage, setCurrentPage] = useState(1)

    const serverSortBy: LeaderSortBy = sortBy === PAGE_SORT ? 'created_at' : (sortBy as LeaderSortBy)

    const {data, refetch} = useQueryLeaderList(searchKeyword, exchange, serverSortBy, currentPage)

    const leaderList = useMemo(() => {
        const list: ILeader[] = [...(data?.data ?? [])]
        if (sortBy === PAGE_SORT) {
            list.sort((a, b) => leaderAllTimeProfit(b) - leaderAllTimeProfit(a))
        }
        return list
    }, [data, sortBy])

    const sortList = useMemo(
        () => [
            {id: 'created_at', value: 'Create At'},
            {id: 'copier', value: 'Copier'},
            {id: 'mdd', value: 'MDD'},
            {id: PAGE_SORT, value: 'Profit (page)'},
        ],
        [],
    )

    useEffect(() => {
        refetch()
    }, [sortBy, currentPage, exchange, searchKeyword])

    useEffect(() => {
        const sortParams = new URLSearchParams(window.location.search).get('sort')
        const currentPageParams = new URLSearchParams(window.location.search).get('page')
        const exchangeParams = new URLSearchParams(window.location.search).get('exchange')
        const keywordParams = new URLSearchParams(window.location.search).get('keyword')
        setSortBy(sortParams || 'created_at')
        setCurrentPage(Number(currentPageParams) || 1)
        setExchange(exchangeParams || '')
        setSearchKeyword(keywordParams || '')
    }, [])

    const onChangeFunction = (e, type = 'sort' || 'page' || 'exchange' || 'search') => {
        if (type === 'sort') {
            setSortBy(e)
            setCurrentPage(1)
            window.history.pushState('', '', `?sort=${e}&page=1&exchange=${exchange}`)
        } else if (type === 'page') {
            setCurrentPage(e)
            window.history.pushState('', '', `?sort=${sortBy}&page=${e}&exchange=${exchange}`)
        } else if (type === 'exchange') {
            setExchange(e)
            setCurrentPage(1)
            window.history.pushState('', '', `?sort=${sortBy}&page=1&exchange=${e}`)
        } else if (type === 'search') {
            setSearchKeyword(e)
            setSortBy('created_at')
            setCurrentPage(1)
            setExchange('')
            window.history.pushState('', '', `?keyword=${e}`)
        }
    }
    return (
        <PageLayout title={'Copy Leader'} className={className}>
            <LeaderSearchContainer
                onChangedSelect={e => onChangeFunction(e, 'exchange')}
                search={searchKeyword}
                exchange={exchange}
                onClick={e => {
                    onChangeFunction(e, 'search')
                }}
                sort={sortBy}
                sortList={sortList}
                onChangedSortBy={e => {
                    onChangeFunction(e, 'sort')
                }}
            />
            <div className={'mt-[30px] space-y-[3px]'}>
                <Text className={'text-ti1'}>Total Leader Count : {data?.pageInfo?.total_count}</Text>
                {sortBy === PAGE_SORT && (
                    <Text className={'text-body3 text-font03'}>
                        Profit 정렬은 서버가 지원하지 않아 현재 페이지 안에서만 적용됩니다.
                    </Text>
                )}
                {sortBy === 'mdd' && <Text className={'text-body3 text-font03'}>MDD는 오름차순으로 정렬됩니다.</Text>}
            </div>
            <LeaderListTable data={leaderList} className={'mt-[10px]'} />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={e => {
                    onChangeFunction(e, 'page')
                }}
                className={'sm:justify-center'}
            />
        </PageLayout>
    )
}

export default CopyLeaderPage
